"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Size = exports.Name = void 0;
var _GlobalSize = _interopRequireDefault(require("../../type-tools/GlobalSize"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Name = exports.Name = /*#__PURE__*/function (Name) {
  Name["ACTIONS_CHAT"] = "actions-chat";
  Name["ACTIONS_LOADING"] = "actions-loading";
  Name["ACTIONS_MEGAPHONE"] = "actions-megaphone";
  Name["ACTIONS_SECURE"] = "actions-secure";
  Name["ACTIONS_SENDING_MESSAGE"] = "actions-sending-message";
  Name["ACTIONS_UPDATE"] = "actions-update";
  Name["ACTIONS_VERIFY"] = "actions-verify";
  Name["CHARTS_ARROWS"] = "charts-arrows";
  Name["CHARTS_BARS"] = "charts-bars";
  Name["CHARTS_DATA_MOVING_UP"] = "charts-data-moving-up";
  Name["CITY_CITY_TREES"] = "city-city-trees";
  Name["CITY_CITY_TYPE_1"] = "city-city-type-1";
  Name["CITY_CITY_TYPE_2"] = "city-city-type-2";
  Name["CITY_HOUSE_TYPE_1"] = "city-house-type-1";
  Name["CITY_HOUSE_TYPE_2"] = "city-house-type-2";
  Name["CITY_HOUSE_TYPE_3"] = "city-house-type-3";
  Name["CITY_HOUSE_SEARCH"] = "city-house-search";
  Name["DOCUMENTS_ASKING_FOR_DATA"] = "documents-asking-for-data";
  Name["DOCUMENTS_CHECKLIST"] = "documents-checklist";
  Name["DOCUMENTS_CONTRACT"] = "documents-contract";
  Name["DOCUMENTS_DOC_APPROVED"] = "documents-doc-approved";
  Name["DOCUMENTS_SELFIE_ID"] = "documents-selfie-id";
  Name["DOCUMENTS_ID"] = "documents-id";
  Name["DOCUMENTS_PAYCHECK"] = "documents-paycheck";
  Name["DOCUMENTS_PAYMENT_STATEMENT"] = "documents-payment-statement";
  Name["DOCUMENTS_WORKING_CARD"] = "documents-working-card";
  Name["FINANCE_BANK"] = "finance-bank";
  Name["FINANCE_BILL"] = "finance-bill";
  Name["FINANCE_CALCULATING_MONEY"] = "finance-calculating-money";
  Name["FINANCE_CREDIT_APPROVED"] = "finance-credit-approved";
  Name["FINANCE_MONEY"] = "finance-money";
  Name["FINANCE_MONEY_TRANSFER"] = "finance-money-transfer";
  Name["FINANCE_PROPERTY_VALUE"] = "finance-property-value";
  Name["FINANCE_SAVING_MONEY"] = "finance-saving-money";
  Name["GESTURES_AGREEMENT"] = "gestures-agreement";
  Name["GESTURES_ASKING"] = "gestures-asking";
  Name["GESTURES_LOVE"] = "gestures-love";
  Name["GESTURES_OFFER_SENT"] = "gestures-offer-sent";
  Name["GESTURES_POINT"] = "gestures-point";
  Name["GESTURES_PROPERTY_LIVE"] = "gestures-property-live";
  Name["GESTURES_PROPERTY_SOLD_OR_RENTED"] = "gestures-property-sold-or-rented";
  Name["GESTURES_RECEIVE_MONEY"] = "gestures-receive-money";
  Name["GESTURES_RECEIVING_KEYS"] = "gestures-receiving-keys";
  Name["GESTURES_REIMBURSEMENT"] = "gestures-reimbursement";
  Name["GESTURES_TECHNOLOGY"] = "gestures-technology";
  Name["GESTURES_THUMBS_UP"] = "gestures-thumbs-up";
  Name["GESTURES_TIME"] = "gestures-time";
  Name["HOMES_FINDING"] = "homes-finding";
  Name["HOMES_KEY"] = "homes-key";
  Name["HOMES_LETTER"] = "homes-letter";
  Name["OBJECTS_ALARM_CLOCK"] = "objects-alarm-clock";
  Name["OBJECTS_BABY_TOY"] = "objects-baby-toy";
  Name["OBJECTS_BADGE"] = "objects-badge";
  Name["OBJECTS_BELL"] = "objects-bell";
  Name["OBJECTS_BIKE"] = "objects-bike";
  Name["OBJECTS_BOOK"] = "objects-book";
  Name["OBJECTS_CALENDAR"] = "objects-calendar";
  Name["OBJECTS_CAMERA"] = "objects-camera";
  Name["OBJECTS_CAR"] = "objects-car";
  Name["OBJECTS_CHAIR"] = "objects-chair";
  Name["OBJECTS_EMPTY_STATE"] = "objects-empty-state";
  Name["OBJECTS_FOOD"] = "objects-food";
  Name["OBJECTS_HEALTH"] = "objects-health";
  Name["OBJECTS_HOME_OFFICE"] = "objects-home-office";
  Name["OBJECTS_IDEA"] = "objects-idea";
  Name["OBJECTS_KEY"] = "objects-key";
  Name["OBJECTS_LOCK"] = "objects-lock";
  Name["OBJECTS_MOBILE"] = "objects-mobile";
  Name["OBJECTS_MUG"] = "objects-mug";
  Name["OBJECTS_NOTEBOOK_TYPE_1"] = "objects-notebook-type-1";
  Name["OBJECTS_NOTEBOOK_TYPE_2"] = "objects-notebook-type-2";
  Name["OBJECTS_PHONE"] = "objects-phone";
  Name["OBJECTS_PLANT"] = "objects-plant";
  Name["OBJECTS_SEARCH"] = "objects-search";
  Name["OBJECTS_SPEECH"] = "objects-speech";
  Name["OBJECTS_TRUCK"] = "objects-truck";
  Name["OBJECTS_DESIGN_TOOL"] = "objects-design-tool";
  Name["OBJECTS_UNLOCKING_DOOR"] = "objects-unlocking-door";
  Name["REPAIR_APPROVED"] = "repair-approved";
  Name["REPAIR_FAUCET"] = "repair-faucet";
  Name["REPAIR_TOOLS"] = "repair-tools";
  Name["SCENIC_PROPERTY_NOT_FOUND"] = "scenic-property-not-found";
  Name["SCENIC_SPOTS_AGENT_DESK_NOTIFICATION"] = "scenic-spots-agent-desk-notification";
  Name["SCENIC_SPOTS_AGENT_OUTSIDE_DOOR"] = "scenic-spots-agent-outside-door";
  Name["SCENIC_SPOTS_AGENT_WITH_PEOPLE_IN_ROW"] = "scenic-spots-agent-with-people-in-row";
  Name["SCENIC_SPOTS_CALENDAR"] = "scenic-spots-calendar";
  Name["SCENIC_SPOTS_CAT"] = "scenic-spots-cat";
  Name["SCENIC_SPOTS_CELEBRATE"] = "scenic-spots-celebrate";
  Name["SCENIC_SPOTS_COFFEE"] = "scenic-spots-coffee";
  Name["SCENIC_SPOTS_COMMUTING"] = "scenic-spots-commuting";
  Name["SCENIC_SPOTS_INSPECTION_TYPE_1"] = "scenic-spots-inspection-type-1";
  Name["SCENIC_SPOTS_INSPECTION_TYPE_2"] = "scenic-spots-inspection-type-2";
  Name["SCENIC_SPOTS_KEY"] = "scenic-spots-key";
  Name["SCENIC_SPOTS_PHOTOGRAPHER"] = "scenic-spots-photographer";
  Name["SCENIC_SPOTS_SAD_PEOPLE_LOOKING_WINDOW"] = "scenic-spots-sad-people-looking-window";
  Name["SCENIC_SPOTS_SELFIE"] = "scenic-spots-selfie";
  Name["SCENIC_SPOTS_TOAST"] = "scenic-spots-toast";
  Name["SCENIC_SPOTS_VISITS"] = "scenic-spots-visits";
  Name["SCENIC_SPOTS_VISIT_CALENDAR"] = "scenic-spots-visit-calendar";
  Name["SCENIC_SPOTS_TRANQUILITY"] = "scenic-spots-tranquility";
  Name["SCENIC_SPOTS_LOOKING_FOR_PROPERTY"] = "scenic-spots-looking-for-property";
  Name["SCENIC_SPOTS_404"] = "scenic-spots-404";
  Name["SOCIAL_PEOPLE_CONNECTED"] = "social-people-connected";
  Name["SOCIAL_SOCIAL_NETWORKS"] = "social-social-networks";
  Name["STATUS_ALERT"] = "status-alert";
  Name["STATUS_APPROVED"] = "status-approved";
  Name["STATUS_ERROR"] = "status-error";
  Name["STATUS_HELP"] = "status-help";
  Name["STATUS_INFO"] = "status-info";
  Name["STATUS_LINK"] = "status-link";
  Name["STATUS_LOCALIZATION"] = "status-localization";
  Name["STATUS_NO_INTERNET"] = "status-no-internet";
  return Name;
}(Name || {});
var Size = exports.Size = function (Size) {
  Size[Size["SMALL"] = _GlobalSize["default"].SMALL] = "SMALL";
  Size[Size["MEDIUM"] = _GlobalSize["default"].MEDIUM] = "MEDIUM";
  Size[Size["LARGE"] = _GlobalSize["default"].LARGE] = "LARGE";
  Size[Size["XLARGE"] = _GlobalSize["default"].XLARGE] = "XLARGE";
  return Size;
}(Size || {});